import React, { useEffect, useState } from 'react';
import * as fonts from '../../../../util/fonts';
import { Column, Row } from '../../../../components/layout';

import './styles.scss';

export interface BannerModalComponentProps {
	style?: any;
	className?: any;
	rowClassName?: any;
	isLogin?: any;
	visibleBannerString?: any;
	currentBannerString?: any;
}

function BannerModalComponent({
	style,
	className,
	isLogin,
	visibleBannerString,
	currentBannerString,
	rowClassName,
}: BannerModalComponentProps) {

	return <Row className={rowClassName ? rowClassName : "banner-modal-row"}>
		<p
			style={style}
			className={className}>
			{isLogin ? visibleBannerString : currentBannerString}
		</p>
	</Row>
}

export default BannerModalComponent;